export const WHATSAPP_MESSAGE =
  "Hola, he visto la web de THE CREW. Quiero contaros mi caso y saber si vuestro sistema de entrenamiento encaja conmigo.";

export const TRAINERS = {
  juanCarlos: {
    name: "Juan Carlos",
    phone: "+34 613 82 02 53",
    whatsappNumber: "34613820253",
    priority: true,
  },
  xavi: {
    name: "Xavi",
    phone: "+34 663 81 29 35",
    whatsappNumber: "34663812935",
    priority: false,
  },
};

export function getWhatsAppUrl(trainer) {
  return `https://wa.me/${trainer.whatsappNumber}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE
  )}`;
}
